import { useState, useEffect } from 'react'
import { api } from 'core/api/ConnectionManager'
import { isNumber } from 'core/utils/typeUtil'
import { IBroadcast } from 'core/models/Broadcast'
import { IGetBroadcastByIdRequest } from './ScheduleItem-types'

export const useConfirmDelete = () => {
    let [isConfirmDelete, setConfirmDelete] = useState<boolean>(false)

    return {
        isConfirmDelete,
        setConfirmDelete,
    }
}

export const useGetBroadcastOnSelect = (id: number, selected: boolean) => {
    const [broadcast, setBroadcast] = useState<IBroadcast | null>(null)

    const getBroadcastById = (broadcastId: number) => {
        api.send<IGetBroadcastByIdRequest, IBroadcast>('getBroadcast', { id: broadcastId }, { hideLoader: true })
            .then((respBroadcast: IBroadcast) => {
                if (respBroadcast) {
                    setBroadcast(respBroadcast)
                }
            })
            .catch(() => {
                setBroadcast(null)
            })
    }

    useEffect(() => {
        if (isNumber(id) && selected) {
            getBroadcastById(id)
        }
    }, [id, selected])

    return {
        broadcast,
    }
}

interface IScheduleDeviceName {
    id: number
    name: string
}

const PREVIEW_LIMIT = 5

export const useScheduleDevicesPreview = (
    scheduleId: number | undefined,
    selected: boolean,
    fallbackCount?: number
) => {
    const [preview, setPreview] = useState<IScheduleDeviceName[]>([])
    const [total, setTotal] = useState(fallbackCount || 0)

    useEffect(() => {
        if (!selected || !scheduleId) {
            setPreview([])
            setTotal(fallbackCount || 0)
            return
        }

        api.send<{ scheduleId: number; sort: string; limit: number }, { data?: IScheduleDeviceName[]; total?: number }>(
            'getScheduleDevices',
            { scheduleId, sort: 'name', limit: PREVIEW_LIMIT },
            { hideLoader: true }
        ).then((res) => {
            const list = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : []
            setPreview(list)
            setTotal(typeof res?.total === 'number' ? res.total : fallbackCount || list.length)
        })
    }, [scheduleId, selected, fallbackCount])

    return { preview, total }
}
